import { ManageTemplateComponent } from "../../../components/manage-template-components";


export const ManageTemplatePage: React.FC = () => {
  return <ManageTemplateComponent />;
};

